import { createAction } from 'redux-actions'
import { API_TIMEOUT_ERROR } from 'Redux/Types/ErrorTypes'

export const apiTimeoutError = createAction(API_TIMEOUT_ERROR)
